// Image and logo imports: room thumbnails + large images, hero slider backgrounds, SVG logos (via ?react for SVGR).
import Room1Img from './img/rooms/1.png';
import Room2Img from './img/rooms/2.png';
import Room3Img from './img/rooms/3.png';
import Room4Img from './img/rooms/4.png';
import Room5Img from './img/rooms/5.png';
import Room6Img from './img/rooms/6.png';
import Room7Img from './img/rooms/7.png';
import Room8Img from './img/rooms/8.png';
import Room1ImgLg from './img/rooms/1-lg.png';
import Room2ImgLg from './img/rooms/2-lg.png';
import Room3ImgLg from './img/rooms/3-lg.png';
import Room4ImgLg from './img/rooms/4-lg.png';
import Room5ImgLg from './img/rooms/5-lg.png';
import Room6ImgLg from './img/rooms/6-lg.png';
import Room7ImgLg from './img/rooms/7-lg.png';
import Room8ImgLg from './img/rooms/8-lg.png';

import Slider1 from './img/heroSlider/1.jpg';
import Slider2 from './img/heroSlider/2.jpg';
import Slider3 from './img/heroSlider/3.jpg';

import LogoDarkSvg from './img/logo-dark.svg';
import LogoWhiteSvg from './img/logo-white.svg';

export const LogoDark = LogoDarkSvg;
export const LogoWhite = LogoWhiteSvg;

const images = {
  Slider1,
  Slider2,
  Slider3,
  Room1Img,
  Room2Img,
  Room3Img,
  Room4Img,
  Room5Img,
  Room6Img,
  Room7Img,
  Room8Img,
  Room1ImgLg,
  Room2ImgLg,
  Room3ImgLg,
  Room4ImgLg,
  Room5ImgLg,
  Room6ImgLg,
  Room7ImgLg,
  Room8ImgLg,
};

export default images;
